<main class="main">
    <div class="container">
        <div class="pageHeader d-flex justify-content-between">
            <h1 class=" mb-4">Review Missed Action Data</h1>
        </div>
        <div class="card-body">
            <form #filterForm="ngForm" class="navbar-form" class="form-floating">
                <div class="row m-0  searchRecordWrapper">
                    <p class="error textError m-0" *ngIf="errorMessage!=null">
                        {{errorMessage}}
                    </p>
                    <div class="col-3  mt-4">
                        <div class="form-floating">
                            <select class="form-select form-control" id="txtClientMasterId"
                                aria-label="Floating label select example" [(ngModel)]="clientMasterId"
                                [ngModelOptions]="{standalone: true}">
                                <option selected disabled value='null'></option>
                                <option value="{{data?.ClientMasterID}}" *ngFor="let data of clientMasterOptionsList">
                                    {{data?.ClientName}}</option>
                            </select>
                            <label for="txtClientMasterId">Client Master Name</label>
                        </div>
                    </div>
                    <div class="col-3 mt-4">
                        <div class="form-floating">
                            <input type="number" class="form-control" id="txtDocId" min="0" placeholder="MasterSheetID"
                                name="MasterSheetID" [(ngModel)]="pagination.masterSheetId"
                                [ngModelOptions]="{standalone: true}">
                            <label for="txtDocId">Master Sheet Id</label>
                        </div>
                        <p *ngIf="validationError" class="text-danger mt-2">{{ validationError }}</p>
                    </div>
                    <div class="col-3 mt-4">
                        <div class="form-floating">
                            <input type="number" class="form-control" id="txtDocId" min="0"
                                placeholder="URLConfigurationMasterID" name="URLConfigurationMasterID"
                                [(ngModel)]="pagination.URLConfigurationMasterID" [ngModelOptions]="{standalone: true}">
                            <label for="txtDocId">URLConfiguration Master Id</label>
                        </div>
                    </div>
                    <div class="col-3 mt-4">
                        <div class="form-floating mb-3 datePicker">
                            <input type="text" placeholder="Process Date" class="form-control" bsDatepicker
                                [bsConfig]="{ isAnimated: true ,dateInputFormat: 'MM/DD/YYYY'}"
                                [(ngModel)]="pagination.ProcessDate" [ngModelOptions]="{standalone: true}" #s1="bsDatepicker"
                                readonly>
                            <label for="txtUrl">Process Date</label>
                            <span class="input-group-text" (click)="s1.toggle()"><i class="fa fa-calendar"></i></span>
                        </div>
                    </div>
                    <div class="col-3 mt-4">
                        <div class="form-floating">
                            <input type="text" class="form-control" id="txtDocURL" min="0" placeholder="Doc URL"
                                name="Doc URL" [(ngModel)]="pagination.documentURL"
                                [ngModelOptions]="{standalone: true}">
                            <label for="txtDocURL">Doc URL</label>
                        </div>
                    </div>
                    <div class="col-3 mt-4">
                        <div class="form-floating mb-3 datePicker">
                            <input type="text" placeholder="Process Date" class="form-control" bsDatepicker
                                [bsConfig]="{ isAnimated: true ,dateInputFormat: 'MM/DD/YYYY'}" [(ngModel)]="pagination.startDate"
                                [ngModelOptions]="{standalone: true}" #s2="bsDatepicker" readonly>
                            <label for="txtUrl">From Date</label>
                            <span class="input-group-text" (click)="s2.toggle()"><i class="fa fa-calendar"></i></span>
                        </div>
                    </div>
                    <div class="col-3 mt-4">
                        <div class="form-floating mb-3 datePicker">
                            <input type="text" placeholder="Process Date" class="form-control" bsDatepicker
                                [bsConfig]="{ isAnimated: true ,dateInputFormat: 'MM/DD/YYYY'}" [(ngModel)]="pagination.endDate"
                                [ngModelOptions]="{standalone: true}" #s3="bsDatepicker" readonly>
                            <label for="txtUrl">To Date</label>
                            <span class="input-group-text" (click)="s3.toggle()"><i class="fa fa-calendar"></i></span>
                        </div>
                    </div>

                    <div class="col-12 mt-3">
                        <div class="d-flex">
                            <button class="btn btn-primary smallBtn" type="submit" (click)="Search(filterForm)"
                                style="height: 47px !important;">Search</button>
                            <!-- <button class="btn btn-primary smallBtn" style="height: 47px !important;"
                                (click)="ExportToXLS()">Export</button> -->
                            <button class="btn btn-default smallBtn" style="height: 47px !important;"
                                (click)="Reset()">Reset</button>

                            <div class="form-check" style="margin-left: 20px;">
                                <input class="form-check-input" type="checkbox" id="wrapText" name="wrapText"
                                    [(ngModel)]="wrapText" [ngModelOptions]="{standalone: true}">
                                <label class="form-check-label p-0">Wrap Text</label>
                            </div>

                            <!-- <div class="d-flex justify-content-end"> -->
                                <button class="btn btn-primary smallBtn" (click)="DownloadCrawledDataErrors()"
                                    style="height: 47px !important;">Download Crawled Data Errors</button>
                            <!-- </div> -->
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="pageHeader d-flex justify-content-between">
            <h1 class=" mb-4">Source URL Details</h1>
        </div>
        <div class="card-body rlSearchCard scrollTo">
            <div class="row m-0">
                <!-- <h6 class="text-center" *ngIf="MissedActionDataSearchList1?.length==0">No Records found.
                        </h6> -->
                <div class="col-12 table-responsive">
                    <table class="table table-bordered" [ngClass]="{'wrapTable':wrapText==true}">
                        <thead>
                            <tr style="border-bottom-width: 0px">
                                <th style="width: 10%; text-align: center;min-width: 200px;">
                                    URL Configuration Master ID
                                </th>
                                <th style="width: 10%; text-align: center;min-width: 120px;">
                                    Mastersheet ID
                                </th>
                                <th style="width: 10%; text-align: center;min-width: 120px;">
                                    Client Name
                                </th>
                                <th style="width: 10%; text-align: center;min-width: 200px;">
                                    Source URL
                                </th>
                                <th style="width: 10%; text-align: center;min-width: 200px;">
                                    Source URL XPath
                                </th>
                                <th style="width: 10%; text-align: center;min-width: 200px;">
                                    Child URL XPath
                                </th>
                                <th style="width: 10%; text-align:center; min-width: 200px;">
                                    RegLake Status
                                </th>
                                <th style="width: 10%; text-align: center;min-width: 120px;">
                                    Push to CMS
                                </th>
                                <th style="width: 10%; text-align: center;min-width: 175px;">
                                    Is Selenium Required
                                </th>
                                <th style="width: 10%; text-align: center;min-width: 120px;">
                                    Browser Type
                                </th>
                                <th style="width: 10%; text-align:center; min-width: 250px;">
                                    Number of Records Crawl from URL
                                </th>
                                <th style="width: 10%; text-align: center;min-width: 250px;">
                                    Does Data Exist On Source URL
                                </th>
                                <th style="width: 10%; text-align: center;min-width: 150px;">
                                    Pagination XPath
                                </th>
                                <th style="width: 10%; text-align:center; min-width: 150px;">
                                    Click Event Type
                                </th>
                                <th style="width: 10%; text-align: center;min-width: 150px;">
                                    DropdownBox Xpath
                                </th>
                                <th style="width: 10%; text-align:center; min-width: 120px;">
                                    Visible Text
                                </th>
                                <th style="width: 10%; text-align:center; min-width: 100px;">
                                    Date Field
                                </th>
                                <th style="width: 10%; text-align:center; min-width: 200px;">
                                    URL Process Delay for CE
                                </th>
                                <!-- <th style="width:5%;min-width: 190px;text-align: center;" rowspan="2">Action
                                            </th> -->
                            </tr>
                            <!-- <tr style="border-width:0">                          
                                    </tr> -->
                        </thead>
                        <tbody>
                            <tr *ngIf="MissedActionDataSearchList1?.length==0">
                                <td attr.colspan="{{colSpan}}" class="text-center"
                                    style="padding-top: 70px; padding-bottom: 70px;">
                                    <h6 class="text-center" style="color: red;" *ngIf="MissedActionDataSearchList1?.length==0">
                                        No Record Found
                                    </h6>
                                </td>
                            </tr>
                            <tr *ngFor="let data of MissedActionDataSearchList1;let i=index;"
                                [style.background-color]="data?.ColorCode!='rgb(0 0 0)' || data?.ColorCode!='#000000' ? data?.ColorCode : null">
        
                                <td style="text-align:center" class="ellipsis" title="{{data?.URLConfigurationMasterID}}">
                                    {{data?.URLConfigurationMasterID}}
                                </td>
                                <td style="text-align:center" class="ellipsis" title="{{data?.MastersheetID}}">
                                    {{data?.MastersheetID}}
                                </td>
                                <td style="text-align:center" class="ellipsis" title="{{data?.ClientName}}">
                                    {{data?.ClientName}}
                                </td>
                                <td style="width: 10%; text-align:center" class="ellipsis" title="{{data?.SourceURL}}">
                                    <a href="javascript:void(0)" title="{{data?.SourceURL}}"
                                        (click)="NavigateToSourceUrl(data?.ID,data.SourceURL)">{{data?.SourceURL}}</a>
                                    <!-- {{data?.SourceURL}} -->
                                </td>
                                <td style="text-align:center" class="ellipsis" title="{{data?.xPath}}">
                                    <!-- Copy Button (Displayed only if data?.xPath is present) -->
                                    <button *ngIf="data?.xPath" type="button" style="border: none;" (click)="copyToClipboard(data?.xPath)">
                                        <i class="fa fa-clipboard"></i>
                                    </button>
                                    {{data?.xPath}}
                                </td>
                                <td style="text-align:center" class="ellipsis" title="{{data?.ChildURLXPath}}">
                                     <!-- Copy Button (Displayed only if data?.xPath is present) -->
                                     <button *ngIf="data?.ChildURLXPath" type="button" style="border: none;" (click)="copyToClipboard(data?.ChildURLXPath)">
                                        <i class="fa fa-clipboard"></i>
                                    </button>
                                    {{data?.ChildURLXPath}}
                                </td>
                                <td style="width:5%; text-align:center" class="ellipsis" title=" {{data?.StatusName}}">
                                    {{data?.StatusName}}
                                </td>
                                <td style="text-align:center" class="ellipsis" title="{{data?.PushToCMS}}">
                                    {{data?.PushToCMS}}
                                </td>
                                <td style="text-align:center" class="ellipsis" title="{{data?.IsSeleniumRequired}}">
                                    {{data?.IsSeleniumRequired}}
                                </td>
                                <td style="text-align:center" class="ellipsis" title="{{data?.BrowserType}}">
                                    {{data?.BrowserType}}
                                </td>
                                <td style="width:5%; text-align:center" class="ellipsis"
                                    title=" {{data?.NoOfRecordCrawlFromURL}}">
                                    {{data?.NoOfRecordCrawlFromURL}}
                                </td>
                                <td style="text-align:center" class="ellipsis" title="{{data?.DoesDataExistOnSourceURL}}">
                                    {{data?.DoesDataExistOnSourceURL}}
                                </td>
                                <td style="text-align:center" class="ellipsis" title="{{data?.PaginationXPath}}">
                                     <!-- Copy Button (Displayed only if data?.xPath is present) -->
                                     <button *ngIf="data?.PaginationXPath" type="button" style="border: none;" (click)="copyToClipboard(data?.PaginationXPath)">
                                        <i class="fa fa-clipboard"></i>
                                    </button>
                                    {{data?.PaginationXPath}}
                                </td>
                                <td style="width:5%; text-align:center" class="ellipsis" title=" {{data?.ClickEventType}}">
                                    {{data?.ClickEventType}}
                                </td>
                                <td style="text-align:center" class="ellipsis" title="{{data?.DropdownBox_Xpath}}">
                                     <!-- Copy Button (Displayed only if data?.xPath is present) -->
                                     <button *ngIf="data?.DropdownBox_Xpath" type="button" style="border: none;" (click)="copyToClipboard(data?.DropdownBox_Xpath)">
                                        <i class="fa fa-clipboard"></i>
                                    </button>
                                    {{data?.DropdownBox_Xpath}}
                                </td>
                                <td style="text-align:center" class="ellipsis" title="{{data?.VisibleText}}">
                                    {{data?.VisibleText}}
                                </td>
                                <td style="text-align:center" class="ellipsis" title="{{data?.date_field}}">
                                    {{data?.date_field}}
                                </td>
                                <td style="width:5%; text-align:center" class="ellipsis"
                                    title=" {{data?.URLProcessDelayForCE}}">
                                    {{data?.URLProcessDelayForCE}}
                                </td>
                            <tr *ngIf="MissedActionDataSearchList1?.length<=4 && MissedActionDataSearchList1?.length!=0">
                                <td attr.colspan="{{colSpan}}" class="text-center" style="padding-bottom: 142px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- </perfect-scrollbar> -->
                </div>
            </div>
        </div>

        <div class="pageHeader d-flex justify-content-between">
            <h1 class=" mb-4">Source URL XPath Details</h1>
        </div>
        <div class="card-body rlSearchCard scrollTo">
            <div class="row m-0">
                <!-- <h6 class="text-center" *ngIf="MissedActionDataSearchList2?.length==0">No Records found.
                </h6> -->
                <div class="col-12 table-responsive">
                    <table class="table table-bordered" [ngClass]="{'wrapTable':wrapText==true}">
                        <thead>
                            <tr style="border-bottom-width: 0px">
                                <th style="width: 5%; text-align: center; min-width: 150px;">
                                    URL Configuration Detail ID
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 150px;">
                                    URL Configuration Master ID
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Mastersheet ID
                                </th>
                                <th style="width: 5%; text-align:center; min-width: 120px;">
                                    Field Master Name
                                </th>
                                <th style="width: 5%; text-align:center; min-width: 120px;">
                                    Prefix
                                </th>
                                <th style="width: 5%; text-align:center; min-width: 200px;">
                                    xPath
                                </th>
                                <th style="width: 5%; text-align:center; min-width: 120px;">
                                    Data Level
                                </th>
                                <th style="width: 5%; text-align:center; min-width: 120px;">
                                    Inclusion Keywords
                                </th>
                                <th style="width: 5%; text-align:center; min-width: 120px;">
                                    Inclusion Rule
                                </th>
                                <th style="width: 5%; text-align:center; min-width: 120px;">
                                    Exclusion Keywords
                                </th>
                                <th style="width: 5%; text-align:center; min-width: 120px;">
                                    Exclusion Rule
                                </th>
                            </tr>

                            <!-- <tr style="border-width:0">                          
                            </tr> -->
                        </thead>
                        <tbody>
                            <tr *ngIf="MissedActionDataSearchList2?.length==0">
                                <td attr.colspan="{{colSpan}}" class="text-center"
                                    style="padding-top: 70px; padding-bottom: 70px;">
                                    <h6 class="text-center" style="color: red;"
                                        *ngIf="MissedActionDataSearchList2?.length==0">
                                        No Record Found
                                    </h6>
                                </td>
                            </tr>
                            <tr *ngFor="let data of MissedActionDataSearchList2;let i=index;"
                                [style.background-color]="data?.ColorCode!='rgb(0 0 0)' || data?.ColorCode!='#000000' ? data?.ColorCode : null">

                                <td style="width: 5%;text-align:center" class="ellipsis"
                                    title="{{data?.URLConfigurationDetailID}}">
                                    {{data?.URLConfigurationDetailID}}
                                </td>
                                <td style="width: 5%;text-align:center" class="ellipsis"
                                    title="{{data?.URLConfigurationMasterID}}">
                                    {{data?.URLConfigurationMasterID}}
                                </td>
                                <td style="width: 5%;text-align:center" class="ellipsis"
                                    title="{{data?.MastersheetID}}">
                                    {{data?.MastersheetID}}
                                </td>
                                <td style="width: 5%;text-align:center" class="ellipsis" title="{{data?.Alias}}">
                                    {{data?.Alias}}
                                </td>
                                <td style="width: 5%;text-align:center" class="ellipsis" title="{{data?.Prefix}}">
                                    {{data?.Prefix}}
                                </td>
                                <td style="width: 5%;text-align:center" class="ellipsis" title="{{data?.xPath}}">
                                     <!-- Copy Button (Displayed only if data?.xPath is present) -->
                                     <button *ngIf="data?.xPath" type="button" style="border: none;" (click)="copyToClipboard(data?.xPath)">
                                        <i class="fa fa-clipboard"></i>
                                    </button>
                                    {{data?.xPath}}
                                </td>
                                <td style="width: 5%;text-align:center" class="ellipsis" title="{{data?.DataLevel}}">
                                    {{data?.DataLevel}}
                                </td>
                                <td style="width: 5%;text-align:center" class="ellipsis" title="{{data?.InclusionKeywords}}">
                                     <!-- Copy Button (Displayed only if data?.xPath is present) -->
                                     <button *ngIf="data?.InclusionKeywords" type="button" style="border: none;" (click)="copyToClipboard(data?.InclusionKeywords)">
                                        <i class="fa fa-clipboard"></i>
                                    </button>
                                    {{data?.InclusionKeywords}}
                                </td>
                                <td style="width: 5%;text-align:center" class="ellipsis" title="{{data?.InclusionRule}}">
                                    {{data?.InclusionRule}}
                                </td>
                                <td style="width: 5%;text-align:center" class="ellipsis" title="{{data?.ExclusionKeywords}}">
                                     <!-- Copy Button (Displayed only if data?.xPath is present) -->
                                     <button *ngIf="data?.ExclusionKeywords" type="button" style="border: none;" (click)="copyToClipboard(data?.ExclusionKeywords)">
                                        <i class="fa fa-clipboard"></i>
                                    </button>
                                    {{data?.ExclusionKeywords}}
                                </td>
                                <td style="width: 5%;text-align:center" class="ellipsis" title="{{data?.ExclusionRule}}">
                                    {{data?.ExclusionRule}}
                                </td>
                            <tr
                                *ngIf="MissedActionDataSearchList2?.length<=4 && MissedActionDataSearchList2?.length!=0">
                                <td attr.colspan="{{colSpan}}" class="text-center" style="padding-bottom: 142px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- </perfect-scrollbar> -->
                </div>
            </div>
        </div>

        <div class="pageHeader d-flex justify-content-between">
            <h1 class=" mb-4">Todays Processed Record Status</h1>
        </div>
        <div class="card-body rlSearchCard scrollTo">
            <div class="row m-0">
                <!-- <h6 class="text-center" *ngIf="MissedActionDataSearchList3?.length==0">No Records found.
                </h6> -->
                <div class="col-12 table-responsive">
                    <table class="table table-bordered" [ngClass]="{'wrapTable':wrapText==true}">
                        <thead>
                            <tr style="border-bottom-width: 0px">
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Crawled JSON ID
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 175px;">
                                    URL Configuration Master ID
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 90px;">
                                    Client Name
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Error Message
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Source URL Error
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Field Level Error
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 150px;">
                                    Total Received Records
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Processed Records
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Error Records
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 100px;">
                                    Created On
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Crawled Data
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Processed Data
                                </th>
                            </tr>

                        </thead>
                        <tbody>
                            <tr *ngIf="MissedActionDataSearchList3?.length==0">
                                <td attr.colspan="{{colSpan}}" class="text-center"
                                    style="padding-top: 70px; padding-bottom: 70px;">
                                    <h6 class="text-center" style="color: red;"
                                        *ngIf="MissedActionDataSearchList3?.length==0">
                                        No Record Found
                                    </h6>
                                </td>
                            </tr>
                            <tr *ngFor="let data of MissedActionDataSearchList3;let i=index;"
                                [style.background-color]="data?.ColorCode!='rgb(0 0 0)' || data?.ColorCode!='#000000' ? data?.ColorCode : null">

                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.CrawledJSONID}}">
                                    {{data?.CrawledJSONID}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.URLConfigurationMasterID}}">
                                    {{data?.URLConfigurationMasterID}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.ClientName}}">
                                    {{data?.ClientName}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.ErrorMessage}}">
                                    <!-- Copy Button (Displayed only if data?.xPath is present) -->
                                    <button *ngIf="data?.ErrorMessage" type="button" style="border: none;" (click)="copyToClipboard(data?.ErrorMessage)">
                                        <i class="fa fa-clipboard"></i>
                                    </button>
                                    {{data?.ErrorMessage}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.SourceURLError}}">
                                    {{data?.SourceURLError}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.FieldLevelError}}">
                                    {{data?.FieldLevelError}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.TotalReceivedRecords}}">
                                    {{data?.TotalReceivedRecords}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.ProcessedRecords}}">
                                    {{data?.ProcessedRecords}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.ErrorRecords}}">
                                    {{data?.ErrorRecords}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.CreatedOn|date:'MM/dd/YYYY'}}">
                                    {{data?.CreatedOn|date:'MM/dd/YYYY'}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis">
                                    <!-- {{data?.CrawledData}} -->
                                    <a (click)="downloadFile(data?.CrawledData,'CrawledData')" title="Download XML File"
                                        class="blue-link">
                                        Download Crawled Data
                                    </a>
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis">
                                    <!-- {{data?.CrawledData}} -->
                                    <a (click)="downloadFile(data?.ProcessedData,'ProcessedData')"
                                        title="Download XML File" class="blue-link">
                                        Download Processed Data
                                    </a>
                                </td>

                            <tr
                                *ngIf="MissedActionDataSearchList3?.length<=4 && MissedActionDataSearchList3?.length!=0">
                                <td attr.colspan="{{colSpan}}" class="text-center" style="padding-bottom: 142px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="pageHeader d-flex justify-content-between">
            <h1 class=" mb-4">Last 10 Days Processed Records Status</h1>
        </div>
        <div class="card-body rlSearchCard scrollTo">
            <div class="row m-0">
                <!-- <h6 class="text-center" *ngIf="MissedActionDataSearchList3?.length==0">No Records found.
                </h6> -->
                <div class="col-12 table-responsive">
                    <table class="table table-bordered" [ngClass]="{'wrapTable':wrapText==true}">
                        <thead>
                            <tr style="border-bottom-width: 0px">
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Crawled JSON ID
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 175px;">
                                    URL Configuration Master ID
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 90px;">
                                    Client Name
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Error Message
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Source URL Error
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Field Level Error
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 150px;">
                                    Total Received Records
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Processed Records
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Error Records
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 100px;">
                                    Created On
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Crawled Data
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Processed Data
                                </th>
                            </tr>

                        </thead>
                        <tbody>
                            <tr *ngIf="MissedActionDataSearchList4?.length==0">
                                <td attr.colspan="{{colSpan}}" class="text-center"
                                    style="padding-top: 70px; padding-bottom: 70px;">
                                    <h6 class="text-center" style="color: red;"
                                        *ngIf="MissedActionDataSearchList4?.length==0">
                                        No Record Found
                                    </h6>
                                </td>
                            </tr>
                            <tr *ngFor="let data of MissedActionDataSearchList4;let i=index;"
                                [style.background-color]="data?.ColorCode!='rgb(0 0 0)' || data?.ColorCode!='#000000' ? data?.ColorCode : null">

                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.CrawledJSONID}}">
                                    {{data?.CrawledJSONID}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.URLConfigurationMasterID}}">
                                    {{data?.URLConfigurationMasterID}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.ClientName}}">
                                    {{data?.ClientName}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.ErrorMessage}}">
                                    <!-- Copy Button (Displayed only if data?.xPath is present) -->
                                    <button *ngIf="data?.ErrorMessage" type="button" style="border: none;" (click)="copyToClipboard(data?.ErrorMessage)">
                                        <i class="fa fa-clipboard"></i>
                                    </button>
                                    {{data?.ErrorMessage}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.SourceURLError}}">
                                    {{data?.SourceURLError}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.FieldLevelError}}">
                                    {{data?.FieldLevelError}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.TotalReceivedRecords}}">
                                    {{data?.TotalReceivedRecords}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.ProcessedRecords}}">
                                    {{data?.ProcessedRecords}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.ErrorRecords}}">
                                    {{data?.ErrorRecords}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.CreatedOn|date:'MM/dd/YYYY'}}">
                                    {{data?.CreatedOn|date:'MM/dd/YYYY'}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis">
                                    <!-- {{data?.CrawledData}} -->
                                    <a (click)="downloadFile(data?.CrawledData,'CrawledData')" title="Download XML File"
                                        class="blue-link">
                                        Download Crawled Data
                                    </a>
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis">
                                    <!-- {{data?.CrawledData}} -->
                                    <a (click)="downloadFile(data?.ProcessedData,'ProcessedData')"
                                        title="Download XML File" class="blue-link">
                                        Download Processed Data
                                    </a>
                                </td>

                            <tr
                                *ngIf="MissedActionDataSearchList4?.length<=4 && MissedActionDataSearchList4?.length!=0">
                                <td attr.colspan="{{colSpan}}" class="text-center" style="padding-bottom: 142px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="pageHeader d-flex justify-content-between">
            <h1 class=" mb-4">Crawled Master Data Details</h1>
        </div>
        <div class="card-body rlSearchCard scrollTo">
            <div class="row m-0">
                <!-- <h6 class="text-center" *ngIf="MissedActionDataSearchList4?.length==0">No Records found.
                </h6> -->
                <div class="col-12 table-responsive">
                    <table class="table table-bordered" [ngClass]="{'wrapTable':wrapText==true}">
                        <thead>
                            <tr style="border-bottom-width: 0px">
                                <th style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>Crawled Master Data ID</span>
                                        <span (click)="sortData('CrawledMasterDataID')"><i
                                                class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 150px;">
                                    <!-- URL Detail ID -->
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>URL Detail ID</span>
                                        <span (click)="sortData('UrlDetailID')"><i class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 100px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>CMS ID</span>
                                        <span (click)="sortData('CMSID')"><i class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>PDF File Name</span>
                                        <span (click)="sortData('PDFFileName')"><i class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>Translated PDF File Name</span>
                                        <span (click)="sortData('TranslatedPDFFileName')"><i
                                                class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>Previous HTML File Name</span>
                                        <span (click)="sortData('PreviousHTMLFileName')"><i
                                                class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>Error Message</span>
                                        <span (click)="sortData('ErrorMessage')"><i class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>PDF Conversion Error</span>
                                        <span (click)="sortData('PDFConversionError')"><i class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>Translation Error Message</span>
                                        <span (click)="sortData('TranslationErrorMessage')"><i
                                                class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 150px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>Language</span>
                                        <span (click)="sortData('Language')"><i class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>RL Record Status</span>
                                        <span (click)="sortData('RLRecordStatus')"><i class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 150px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>Last Updated On</span>
                                        <span (click)="sortData('LastUpdatedOn')"><i class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>RCM API Request</span>
                                        <span (click)="sortData('RCMAPIRequest')"><i class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>RCM API Response</span>
                                        <span (click)="sortData('RCMAPIResponse')"><i class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>Return XML</span>
                                        <span (click)="sortData('ReturnXML')"><i class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 150px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>Is Circuit Breaker</span>
                                        <span (click)="sortData('IsCircuitBreaker')"><i class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 150px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>RCM API Message</span>
                                        <span (click)="sortData('RCMAPIMessage')"><i class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 170px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>PDF File Updated On</span>
                                        <span (click)="sortData('PDFFileUpdatedOn')"><i class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 170px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>Is Text Translated</span>
                                        <span (click)="sortData('IsTextTranslated')"><i class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 170px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>Text Translated On</span>
                                        <span (click)="sortData('TextTranslatedOn')"><i class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 150px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>File OCRed On</span>
                                        <span (click)="sortData('FileOCRedOn')"><i class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 230px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>File Translated To English On</span>
                                        <span (click)="sortData('FileTranslatedToEnglishOn')"><i
                                                class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 180px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>Vantage Transaction ID</span>
                                        <span (click)="sortData('VantageTransactionID')"><i
                                                class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 230px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>File Converted To HTML On</span>
                                        <span (click)="sortData('FileConvertedToHTMLOn')"><i
                                                class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 270px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>Insurance Form File Compared On</span>
                                        <span (click)="sortData('InsuranceFormFileComparedOn')"><i
                                                class="fa fa-sort"></i></span>
                                    </div>
                                </th>


                                <!-- <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('CrawledMasterDataID')">
                                    Crawled Master Data ID
                                    <input type="text" [(ngModel)]="filters.crawledMasterDataID" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('UrlDetailID')">
                                    URL Detail ID
                                    <input type="text" [(ngModel)]="filters.urlDetailID" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('Language')">
                                    Language
                                    <input type="text" [(ngModel)]="filters.language" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('RLRecordStatus')">
                                    RL Record Status
                                    <input type="text" [(ngModel)]="filters.rlRecordStatus" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('LastUpdatedOn')">
                                    Last Updated On
                                    <input type="text" [(ngModel)]="filters.lastUpdatedOn" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('PDFFileName')">
                                    PDF File Name
                                    <input type="text" [(ngModel)]="filters.pdfFileName" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('CMSID')">
                                    CMS ID
                                    <input type="text" [(ngModel)]="filters.cmsID" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('RCMAPIRequest')">
                                    RCM API Request
                                    <input type="text" [(ngModel)]="filters.rcmAPIRequest" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('RCMAPIResponse')">
                                    RCM API Response
                                    <input type="text" [(ngModel)]="filters.rcmAPIResponse" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('ReturnXML')">
                                    Return XML
                                    <input type="text" [(ngModel)]="filters.returnXML" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('IsCircuitBreaker')">
                                    Is Circuit Breaker
                                    <input type="text" [(ngModel)]="filters.isCircuitBreaker" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('PDFConversionError')">
                                    PDF Conversion Error
                                    <input type="text" [(ngModel)]="filters.pdfConversionError" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('RCMAPIMessage')">
                                    RCM API Message
                                    <input type="text" [(ngModel)]="filters.rcmAPIMessage" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('PreviousHTMLFileName')">
                                    Previous HTML File Name
                                    <input type="text" [(ngModel)]="filters.previousHTMLFileName" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('PDFFileUpdatedOn')">
                                    PDF File Updated On
                                    <input type="text" [(ngModel)]="filters.pdfFileUpdatedOn" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('TranslationErrorMessage')">
                                    Translation Error Message
                                    <input type="text" [(ngModel)]="filters.translationErrorMessage" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('IsTextTranslated')">
                                    Is Text Translated
                                    <input type="text" [(ngModel)]="filters.isTextTranslated" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('TextTranslatedOn')">
                                    Text Translated On
                                    <input type="text" [(ngModel)]="filters.textTranslatedOn" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('FileOCRedOn')">
                                    File OCRed On
                                    <input type="text" [(ngModel)]="filters.fileOCRedOn" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('ErrorMessage')">
                                    Error Message
                                    <input type="text" [(ngModel)]="filters.errorMessage" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('FileTranslatedToEnglishOn')">
                                    File Translated To English On
                                    <input type="text" [(ngModel)]="filters.fileTranslatedToEnglishOn" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('VantageTransactionID')">
                                    Vantage Transaction ID
                                    <input type="text" [(ngModel)]="filters.vantageTransactionID" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('FileConvertedToHTMLOn')">
                                    File Converted To HTML On
                                    <input type="text" [(ngModel)]="filters.fileConvertedToHTMLOn" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('InsuranceFormFileComparedOn')">
                                    Insurance Form File Compared On
                                    <input type="text" [(ngModel)]="filters.insuranceFormFileComparedOn" (input)="applyFilters()"/>
                                  </th>
                                  <th style="width: 5%; text-align: center; min-width: 120px;" (click)="sortData('TranslatedPDFFileName')">
                                    Translated PDF File Name
                                    <input type="text" [(ngModel)]="filters.translatedPDFFileName" (input)="applyFilters()"/>
                                  </th> -->
                            </tr>
                            <tr>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Crawled Master DataI D"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.crawledMasterDataID"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Url Detail ID"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.urlDetailID"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter CMS ID"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.cmsID" (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter PDF File Name"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.pdfFileName"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Translated PDF File Name"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.translatedPDFFileName"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Previous HTML File Name"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.previousHTMLFileName"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Error Message"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.errorMessage"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter PDF Conversion Error"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.pdfConversionError"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Translation Error Message"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.translationErrorMessage"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Language"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.language" (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter RL Record Status"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.rlRecordStatus"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Last Updated On"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.lastUpdatedOn"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter RCM API Request"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.rcmAPIRequest"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter RCM API Response"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.rcmAPIResponse"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Return XML"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.returnXML" (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Is Circuit Breaker"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.isCircuitBreaker"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter RCM API Message"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.rcmAPIMessage"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter PDF File Updated On"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.pdfFileUpdatedOn"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Is Text Translated"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.isTextTranslated"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Text Translated On"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.textTranslatedOn"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter File OCRed On"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.fileOCRedOn"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter File Translated To English On"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.fileTranslatedToEnglishOn"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Vantage Transaction ID"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.vantageTransactionID"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter File Converted To HTML On"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.fileConvertedToHTMLOn"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Insurance Form File Compared On"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.insuranceFormFileComparedOn"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <!-- <th></th> -->
                            </tr>

                        </thead>
                        <tbody>
                            <tr *ngIf="filteredData?.length==0">
                                <td attr.colspan="{{colSpan}}" class="text-center"
                                    style="padding-top: 70px; padding-bottom: 70px;">
                                    <h6 class="text-center" style="color: red;"
                                        *ngIf="MissedActionDataSearchList5?.length==0">
                                        No Record Found
                                    </h6>
                                </td>
                            </tr>
                            <tr *ngFor="let data of filteredData;let i=index;"
                                [style.background-color]="data?.ColorCode!='rgb(0 0 0)' || data?.ColorCode!='#000000' ? data?.ColorCode : null">

                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.CrawledMasterDataID}}">
                                    {{data?.CrawledMasterDataID}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.UrlDetailID}}">
                                    {{data?.UrlDetailID}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.CMSID}}">
                                    {{data?.CMSID}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.PDFFileName}}">
                                    <a href="{{data?.PDFFileNameURL}}" target="_blank">{{data?.PDFFileName}}</a>
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.TranslatedPDFFileName}}">
                                    <a href="{{data?.TranslatedPDFFileNameURL}}" target="_blank">{{data?.TranslatedPDFFileName}}</a>
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.PreviousHTMLFileName}}">
                                    <!-- Copy Button (Displayed only if data?.xPath is present) -->
                                    <button *ngIf="data?.PreviousHTMLFileName" type="button" style="border: none;" (click)="copyToClipboard(data?.PreviousHTMLFileName)">
                                        <i class="fa fa-clipboard"></i>
                                    </button>
                                    {{data?.PreviousHTMLFileName}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.ErrorMessage}}">
                                    <!-- Copy Button (Displayed only if data?.xPath is present) -->
                                    <button *ngIf="data?.ErrorMessage" type="button" style="border: none;"
                                        (click)="copyToClipboard(data?.ErrorMessage)">
                                        <i class="fa fa-clipboard"></i>
                                    </button>
                                    {{data?.ErrorMessage}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.PDFConversionError}}">
                                     <!-- Copy Button (Displayed only if data?.xPath is present) -->
                                     <button *ngIf="data?.PDFConversionError" type="button" style="border: none;" (click)="copyToClipboard(data?.PDFConversionError)">
                                        <i class="fa fa-clipboard"></i>
                                    </button>
                                    {{data?.PDFConversionError}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.TranslationErrorMessage}}">
                                    <!-- Copy Button (Displayed only if data?.xPath is present) -->
                                    <button *ngIf="data?.TranslationErrorMessage" type="button" style="border: none;" (click)="copyToClipboard(data?.TranslationErrorMessage)">
                                        <i class="fa fa-clipboard"></i>
                                    </button>
                                    {{data?.TranslationErrorMessage}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.Language}}">
                                    {{data?.Language}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.RLRecordStatus}}">
                                    {{data?.RLRecordStatus}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.LastUpdatedOn|date:'MM/dd/YYYY'}}">
                                    {{data?.LastUpdatedOn|date:'MM/dd/YYYY'}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis">
                                    <!-- {{data?.RCMAPIRequest}} -->

                                    <a *ngIf="data?.RCMAPIRequest"
                                        (click)="downloadFile(data?.RCMAPIRequest,'RCMAPIRequest')"
                                        title="Download XML File" class="blue-link">
                                        Download RCM API Request Data
                                    </a>
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis">
                                    <!-- {{data?.RCMAPIResponse}} -->
                                    <a *ngIf="data?.RCMAPIResponse"
                                        (click)="downloadFile(data?.RCMAPIResponse,'RCMAPIResponse')"
                                        title="Download XML File" class="blue-link">
                                        Download RCM API Response Data
                                    </a>
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.ReturnXML}}">
                                    {{data?.ReturnXML}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.IsCircuitBreaker}}">
                                    {{data?.IsCircuitBreaker}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.RCMAPIMessage}}">
                                     <!-- Copy Button (Displayed only if data?.xPath is present) -->
                                     <button *ngIf="data?.RCMAPIMessage" type="button" style="border: none;" (click)="copyToClipboard(data?.RCMAPIMessage)">
                                        <i class="fa fa-clipboard"></i>
                                    </button>
                                    {{data?.RCMAPIMessage}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.PDFFileUpdatedOn|date:'MM/dd/YYYY'}}">
                                    {{data?.PDFFileUpdatedOn|date:'MM/dd/YYYY'}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.IsTextTranslated}}">
                                    {{data?.IsTextTranslated}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.TextTranslatedOn|date:'MM/dd/YYYY'}}">
                                    {{data?.TextTranslatedOn|date:'MM/dd/YYYY'}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.FileOCRedOn|date:'MM/dd/YYYY'}}">
                                    {{data?.FileOCRedOn|date:'MM/dd/YYYY'}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.FileTranslatedToEnglishOn|date:'MM/dd/YYYY'}}">
                                    {{data?.FileTranslatedToEnglishOn|date:'MM/dd/YYYY'}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.VantageTransactionID}}">
                                    {{data?.VantageTransactionID}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.FileConvertedToHTMLOn|date:'MM/dd/YYYY'}}">
                                    {{data?.FileConvertedToHTMLOn|date:'MM/dd/YYYY'}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.InsuranceFormFileComparedOn|date:'MM/dd/YYYY'}}">
                                    {{data?.InsuranceFormFileComparedOn|date:'MM/dd/YYYY'}}
                                </td>

                            <tr
                                *ngIf="MissedActionDataSearchList5?.length<=4 && MissedActionDataSearchList5?.length!=0">
                                <td attr.colspan="{{colSpan}}" class="text-center" style="padding-bottom: 142px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="pageHeader d-flex justify-content-between">
            <h1 class=" mb-4">Crawled Details for All Fields</h1>
        </div>
        <div class="card-body rlSearchCard scrollTo">
            <div class="row m-0">
                <!-- <h6 class="text-center" *ngIf="MissedActionDataSearchList5?.length==0">No Records found.
                </h6> -->
                <div class="col-12 table-responsive">
                    <table class="table table-bordered" [ngClass]="{'wrapTable':wrapText==true}">
                        <thead>
                            <tr style="border-bottom-width: 0px">
                                <th style="width: 5%; text-align: center; text-align: center; min-width: 120px;">
                                    Crawled Detail Data ID
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 150px;">
                                    Crawled Master Data ID
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Batch Detail ID
                                </th>
                                <th style="width: 5%; text-align: center; text-align: center; min-width: 120px;">
                                    Field Master Name
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Crawled Field Value
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Original Crawled Value
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Is Error
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Error
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 150px;">
                                    Translation Error Message
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Is Circuit Breaker
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    Created On
                                </th>
                            </tr>

                        </thead>
                        <tbody>
                            <tr *ngIf="MissedActionDataSearchList6?.length==0">
                                <td attr.colspan="{{colSpan}}" class="text-center"
                                    style="padding-top: 70px; padding-bottom: 70px;">
                                    <h6 class="text-center" style="color: red;"
                                        *ngIf="MissedActionDataSearchList6?.length==0">
                                        No Record Found
                                    </h6>
                                </td>
                            </tr>
                            <tr *ngFor="let data of MissedActionDataSearchList6;let i=index;"
                                [style.background-color]="data?.ColorCode!='rgb(0 0 0)' || data?.ColorCode!='#000000' ? data?.ColorCode : null">

                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.CrawledDetailDataID}}">
                                    {{data?.CrawledDetailDataID}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.CrawledMasterDataID}}">
                                    {{data?.CrawledMasterDataID}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.BatchDetailID}}">
                                    {{data?.BatchDetailID}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.Alias}}">
                                    {{data?.Alias}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.CrawledFieldValue}}">
                                    {{data?.CrawledFieldValue}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.OriginalCrawledValue}}">
                                    {{data?.OriginalCrawledValue}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.IsError}}">
                                    {{data?.IsError}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.Error}}">
                                    {{data?.Error}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.TranslationErrorMessage}}">
                                    {{data?.TranslationErrorMessage}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.IsCircuitBreaker}}">
                                    {{data?.IsCircuitBreaker}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.CreatedOn|date:'MM/dd/YYYY'}}">
                                    {{data?.CreatedOn|date:'MM/dd/YYYY'}}
                                </td>

                            <tr
                                *ngIf="MissedActionDataSearchList6?.length<=4 && MissedActionDataSearchList6?.length!=0">
                                <td attr.colspan="{{colSpan}}" class="text-center" style="padding-bottom: 142px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</main>

<app-loader [showLoader]="showLoader"></app-loader>
<notifier-container></notifier-container>